module.exports = __webpack_public_path__ + "static/img/$15.5.6cac4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/$15.5.png
// module id = xNw3
// module chunks = 0